import { BuildVersionService } from '@services/buildVersion/build-version.service';
import { environment } from '@environments/environment';
import { LocalStorageService } from 'ngx-webstorage';
import { isDevMode } from '@angular/core';

export class ProjectVersionHandler {

    localSt: LocalStorageService;
    buildServiceService: BuildVersionService;

    constructor(private localSto: LocalStorageService, private buildService: BuildVersionService) {
        this.localSt = localSto;
        this.buildServiceService = buildService;
    }

    public VersionCheck(redirectURL: string = null) {
        this.buildServiceService.GetLatestBuildVersion().subscribe((result: any) => {
            if (result.json.data.buildVersion === null) {
                //console.log('BUILD VERSION IS MISSING');
                return;
            }

            const localProjectVersion = this.localSt.retrieve('ProjectVersion');
            const currentProjectVersion = result.json.data.buildVersion;

            if (localProjectVersion === undefined || localProjectVersion === null) {
                this.StoreVersionAndRedirect(redirectURL, currentProjectVersion);
              } else {
                if (localProjectVersion !== currentProjectVersion) {
                  this.StoreVersionAndRedirect(redirectURL, currentProjectVersion);
                }
              }
        });
    }

    private StoreVersionAndRedirect(redirectURL: string, projectVersion: string) {
        
        this.localSt.store('ProjectVersion', projectVersion);
        
        const userAgent = navigator.userAgent;
        const isCypress = userAgent.toLowerCase().indexOf('cypress') >= 0;

        if (!isDevMode() && !isCypress) {
            if (redirectURL !== null) {
                window.location.href = redirectURL;
            } else {
                window.location.reload();
            }
        }

    }
}

